export default "//cdn.scentbird.com/assets/frontbird-site/images/coffee_745c90.jpg";